import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import { FaCheck } from 'react-icons/fa'
import { Grid, Row, Col } from "react-bootstrap"
import { graphql, Link } from "gatsby"
import { Parallax } from 'react-parallax'

const renderStrataSection = (section) =>
    <Grid>
      <Row className="heading">
        <Col md={12}>
          <h2>{section.title}</h2>
        </Col>
      </Row>
      {section.description !== null && (
        <Row>
          <Col md={12}>
            <br />
            <p className="no-h" style={{color:"#000"}}>{section.description.description}</p>
          </Col>
        </Row>
      )}
      {section.strataSubsections.map((service, i) => {
        if(service.featureList && service.featureList.length > 0){
          const firstColLength = Math.ceil(service.featureList.length/2)
          const firstColFeatures = service.featureList.slice(0,firstColLength)
          const secondColFeatures = service.featureList.slice(firstColLength)
          return (
            <div key={i}>
              <Row className="heading">
                <Col md={12}>
                <p style={{color:"#000"}}>{service.title}</p>
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <ul className="list list-icons custom-text-color-1">
                  {
                    firstColFeatures.map((feature, j) =>
                      <li key={j}><FaCheck className="fa" key={j}/> {feature} </li>
                    )
                  }
                  </ul>
                </Col>
                <Col md={6}>
                  <ul className="list list-icons custom-text-color-1">
                  {
                    secondColFeatures.map((feature, j) =>
                      <li key={j + firstColLength}><FaCheck className="fa" key={j}/> {feature} </li>
                    )
                  }
                  </ul>
                </Col>
              </Row>
              <br />
            </div>
          )
        } else {
          return <div></div>
        }
      })}
      </Grid>

const StrataIndexPage = ({data}) => {
  const sortedSections = data.allContentfulStrataSection.edges.sort((a,b) => (a.node.order - b.node.order))
  return (
      <Layout>
      <SEO title="Strata Management | Korecki Real Estate Services" description="Korecki Real Estate Services is dedicated to providing strata corporations with the highest level of service and ensuring smooth building operations. With extensive experience in the Strata Management field, you can rely on Korecki Real Estate Services to provide sound advice and guidance." keywords="korecki,Real Estate,Strata Management services, Strata, Strata Management, Strata Property Management, Strata Management, Property Management, Client Property Account System"/>
      <div>
      <Parallax bgImage={require('../../images/seawall_v2.jpg')} bgImageAlt="Strata" strength={200}>
        <Grid>
          <Row>
            <Col md={12}>
              <h1>Strata Management</h1>
            </Col>
          </Row>
        </Grid>
      </Parallax>
        <br />
        {sortedSections.map((section) =>
          <section className="section background" key={section.node.order}>
            {renderStrataSection(section.node)}
          </section>
        )}
        <Grid>
        <section className="last-section background ">
        <div className="row center">
          <Row className="pt-4">
            <Col md={12}>
            <Link to="/strata/request">
              <span className="btn btn-outline btn-primary-1 text-uppercase">Strata Proposal Requests</span>
            </Link>
            </Col>
          </Row>
        </div>
        </section>
      </Grid>
      </div>
    </Layout>
  )
}

export const query = graphql`
  {
      allContentfulStrataSection {
        edges {
          node {
            order
            title
            description {
              description
            }
            strataSubsections {
              title
              featureList
            }
          }
        }
     }
  }
  `
  export default StrataIndexPage
